module.exports = __webpack_public_path__ + "static/media/DSCF0390-zZuoiYgs.5966e510.JPG";